import { Controller, useFormContext, Control } from 'react-hook-form';
import { CustomDateInput, ICustomDateInput } from './Custom/CustomDateInput/CustomDateInput';

interface IFormInput extends ICustomDateInput {
  control?: Control<any>;
  isRequired?: boolean;  
  [x: string]: any;
}

export const FormDateInput = (props: IFormInput) => {
  const { control, ...restProps } = props;
  const methods = useFormContext();
  const _control = methods?.control || control;

  return _control ? (
    <Controller
      control={_control}
      name={restProps?.name}
      render={(renderProps) => {
        const {
          field,
          fieldState: { error },
        } = renderProps;
        const { ref, ...restFieldProps } = field;

        return <CustomDateInput {...restProps} {...restFieldProps} error={error} />;
      }}
    />
  ) : (
    <CustomDateInput {...restProps} />
  );
};
